import React, { useEffect, useRef, useState } from "react";
import exportShare from "../../assets/img/export-share.svg";
import closeX from "../../assets/img/close-x.svg";
import "./header-button.scss";

export default function HeaderButton({ options, isOpen = false, onClick }) {
  const [hasItems, setHasItems] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    const isValid =
      !!options?.length &&
      options.some((option) => !!Object.keys(option.icon).length);
    if (isValid) setHasItems(true);
  }, [options]);

  const handleClick = () => {
    // eslint-disable-next-line no-unused-expressions
    if (hasItems) onClick?.();
  };

  return hasItems ? (
    <div className="header-button-icon" ref={buttonRef}>
      {isOpen && (
        <img
          src={closeX}
          title="close"
          className="header-button-icon__close"
          onClick={handleClick}
        />
      )}
      <img
        className="header-button-icon__export"
        src={exportShare}
        alt="Export icon"
        onClick={handleClick}
      />
    </div>
  ) : null;
}
